export default "__VITE_ASSET__J5Uvia98__"